import { useEffect, useState } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { apiClient } from "../pages/api/apiclient";
import { getNotifications } from "../pages/api/notification";

const useNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const userId = localStorage.getItem("id");
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!userId || !token) return;

    // 1) load existing unread notifications
    getNotifications(userId, token)
      .then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        setNotifications(list.filter((n) => !n.read));
      })
      .catch((err) => console.error("Failed to load notifications", err));

    // 2) listen for new ones live
    const client = new Client({
      webSocketFactory: () => new SockJS(`${apiClient.defaults.baseURL}/ws`),
      reconnectDelay: 5000,
      onConnect: () => {
        client.subscribe(`/topic/user/${userId}`, (msg) => {
          const n = JSON.parse(msg.body);
          setNotifications((prev) =>
            prev.some((p) => p.id === n.id) ? prev : [n, ...prev]
          );
        });
      },
    });
    client.activate();

    return () => {
      client.deactivate();
    };
  }, [userId, token]);

  return { notifications, setNotifications };
};

export default useNotifications;
